/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseLaunchData } from './BaseLaunchData';
import { ExtendedAssignment } from './ExtendedAssignment';
import { ExtendedWork } from './ExtendedWork';
const LTIAssignmentLaunchDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('normal_result')],
    ['assignment', ExtendedAssignment],
    ['submission', /* #__PURE__ */ parsers.maybeNull(ExtendedWork)],
]), BaseLaunchData);
export class LTIAssignmentLaunchData extends BaseLaunchData {
    static decode(input) {
        return LTIAssignmentLaunchDataParser.decode(input).map(res => new LTIAssignmentLaunchData(res));
    }
    static unsafeDecode(input) {
        return LTIAssignmentLaunchData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTIAssignmentLaunchDataParser.encode(data);
    }
    static schema() {
        return LTIAssignmentLaunchDataParser.schema();
    }
}
